const wowApp = require('angular').module('wowApp.shop');
const _ = require('lodash');

wowApp.service('ClearGuestSession', ['CurrentUserService', 'LoginService', 'SessionContext', require('./clear-guest-session-service')]);
wowApp.config(['RestangularProvider', '$windowProvider', require('./restangular')]);
wowApp.config(['$stateProvider', '$urlRouterProvider', '$locationProvider', '$urlMatcherFactoryProvider', require('./routes')]);
wowApp.config(['$httpProvider', '$provide', require('./http')]);
wowApp.config(['$provide', require('./state')]);
wowApp.config(['$provide', require('./location')]);
wowApp.config(['$compileProvider', require('./compile')]);
wowApp.config(['$ocLazyLoadProvider', require('./modules')]);

const whiteList = [
    'https://woolworths-dev.apigee.net',
    'https://woolworths-uat.apigee.net',
    'https://woolworths-prod.apigee.net',
    'https://dev.mobile-api.woolworths.com.au',
    'https://uat.mobile-api.woolworths.com.au',
    'https://prod.mobile-api.woolworths.com.au'
];

wowApp.value('whiteList', {
    urls: whiteList,
    isMatch(urlPath) {
        const getRootUrl = (url) => {
            return url.toString().replace(/^(.*\/\/[^\/?#]*).*$/, '$1');
        };
        return _.includes(whiteList, getRootUrl(urlPath));
    }
});

wowApp.run(['$rootScope', '$state', '$location', 'SettingsService', 'ShopperService', 'LoginService', 'PageMetadataService', 'ShopPageStateService', 'CardSizeService', 'TrolleyService', 'StackchatService', 'CurationService', require('./startup')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/index.js
 **/